import { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    try {
      await axios.post(`${API}/contact`, form);
      setStatus("sent");
      setForm({ name: "", email: "", message: "" });
    } catch {
      setStatus("error");
    }
  };

  return (
    <section id="contact" data-testid="contact-section">
      <h2 className="font-bold text-xl mb-4">Contact us</h2>
      <form onSubmit={handleSubmit} data-testid="contact-form" className="space-y-3">
        <div>
          <label className="font-mono90 text-sm block mb-1" htmlFor="name">Name:</label>
          <input
            id="name"
            data-testid="contact-name-input"
            className="input90"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            required
          />
        </div>
        <div>
          <label className="font-mono90 text-sm block mb-1" htmlFor="email">E-mail:</label>
          <input
            id="email"
            data-testid="contact-email-input"
            className="input90"
            type="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
          />
        </div>
        <div>
          <label className="font-mono90 text-sm block mb-1" htmlFor="message">Message:</label>
          <textarea
            id="message"
            data-testid="contact-message-input"
            className="input90 min-h-[120px]"
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
            required
          />
        </div>
        <button data-testid="contact-form-submit" type="submit" className="btn90" disabled={status === "sending"}>
          {status === "sending" ? "Sending..." : "Send"}
        </button>
        {status === "sent" && (
          <p data-testid="contact-success-message" className="font-mono90 text-sm">Thanks! Your message was sent.</p>
        )}
        {status === "error" && (
          <p data-testid="contact-error-message" className="font-mono90 text-sm">Error: message not sent. Try again.</p>
        )}
      </form>
    </section>
  );
};
